import React, {
  useEffect,
  useState,
  useCallback,
  useMemo,
  useRef,
} from "react";
import { FiSearch } from "react-icons/fi";
import { FaUndo } from "react-icons/fa";
import { MdAdd } from "react-icons/md";
import {
  Autocomplete,
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import Loader from "../../Shared_Components/Loader";
import { API_HOST } from "../../api_utils";
import axios from "axios";
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { TbArrowBackUp } from "react-icons/tb";
import { RiSave2Fill } from "react-icons/ri";

function CashStart(props) {
  const { userDataFromStorage, coloredTheme } = props;
  const [open, setOpen] = useState(false);
  const [cashAdjustModel, setCashAdjustModel] = useState(false);
  const [agentModelData, setAgentModelData] = useState({});
  const [loading, setLoading] = useState(false);
  const [managerAgentCashList, setManagerAgentCashList] = useState([]);
  const [updateCashPayload, setUpdateCashPayload] = useState({
    _id: "",
    cash_in_hand: "",
    agent: "",
    date_set: "",
  });

  const [updateCashSuccess, setUpdateCashSuccess] = useState(false);

  // payload state for cash in hand:
  const [addCashStart, setAddCashStart] = useState({
    agent: "",
    cash_in_hand: "",
    date_set: "",
    id: "",
  });

  // states for filter:
  const [managerLastName, setManagerLastName] = useState("");
  const [agentLastName, setAgentLastName] = useState("");
  const [filterData, setFilterData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [managerNameList, setManagerNameList] = useState([]);
  const [agentNameList, setAgentNameList] = useState([]);

  const [cashInHandSuccess, setCashInHandSuccess] = useState(false);
  const [agentNameForApi, setAgentNameForApi] = useState("");
  const [selectedAgentName, setSelectedAgentName] = useState("");
  const [managerNameForApi, setManagerNameForApi] = useState("");
  const [selectedManagerName, setSelectedManagerName] = useState("");
  const [reportDate, setReportDate] = useState("");
  const [allUsers, setAllUsers] = useState([]);
  const [overAllData, setOverAllData] = useState([]);
  const searchFilterOptionsShowAgent = useRef(true);
  const searchFilterOptionsShowManager = useRef(true);

  const getAllManagerNames = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/users/manager_name_list`;

    const { data } = await axios.get(apiUrl, config);
    if (!data.message) {
      setLoading(false);
      setManagerNameList(data);
    } else {
      setLoading(false);
    }
  };

  const getAllAgentNames = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/users/agent_name_list`;

    const { data } = await axios.get(apiUrl, config);
    if (!data.message) {
      setLoading(false);
      setAgentNameList(data);
    } else {
      setLoading(false);
    }
  };

  const addCashStartHandler = async () => {
    setLoading(true);
    if (
      addCashStart.agent &&
      addCashStart.cash_in_hand &&
      addCashStart.date_set
    ) {
      if (new Date(addCashStart.date_set) > reportDate) {
        try {
          const config = {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${userDataFromStorage.token}`,
            },
          };
          const { data } = await axios.post(
            `${API_HOST}/api/cash_start/add_cash_in_hand`,
            addCashStart,
            config
          );

          if (data) {
            if (data.message) {
              setLoading(false);
              toast.error(data.message);
            } else {
              setLoading(false);
              setCashInHandSuccess(true);
              toast.success("Cash In Hand Details Added Successfully !!!");
              setOpen(false);
            }
          } else {
            setLoading(false);
            toast.error("Something Went Wrong !!!");
          }
        } catch (error) {
          setLoading(false);
          toast.error(error.response.data.message);
        }
      } else {
        setLoading(false);
        toast.warn(
          `Date should be greater than ${
            new Date(reportDate).toISOString().split("T")[0]
          }`
        );
      }
    } else {
      setLoading(false);
      toast.error("Make Sure To Fill All Fields !!!");
    }
  };

  const getCnnyStartDateHandler = async () => {
    const { data } = await axios.get(
      `${API_HOST}/api/users/get_cnny_start_date`
    );
    if (data) {
      if (!data.message) {
        console.log("data::::", data);
        setReportDate(new Date(data[0].cn_ny_start));
      }
    }
  };

  const managerRelatedUserFetch = async (agent) => {
    console.log("here123:::::::::");
    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/users/transaction_user_relation`;

    const { data } = await axios.get(apiUrl, config);
    console.log("data here ::::::::", data);
    if (data) {
      if (!data.message) {
        setLoading(false);
        console.log("data::::::", data);
        // setCashLoanModelData(data);
        setAllUsers(data);
      }
    }
  };

  // get manager list:
  const getCashStartList = async () => {
    setLoading(true);
    let apiUrl = `${API_HOST}/api/users/get_cash_start?page=${currentPage}&pageSize=${pageSize}`;

    const queryParams = [];
    if (managerNameForApi) {
      queryParams.push(`manager_name=${managerNameForApi}`);
    }
    if (agentNameForApi) {
      queryParams.push(`agent_name=${agentNameForApi}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `&${queryString}`;
    }

    const { data } = await axios.get(apiUrl);
    if (data) {
      if (data.message) {
        setLoading(false);
      } else {
        setLoading(false);
        setManagerAgentCashList(data);
        setFilterData(data);
      }
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCashStartList();
    getAllManagerNames();
    getAllAgentNames();
    getCnnyStartDateHandler();
    managerRelatedUserFetch();

    return () => {
      setUpdateCashSuccess(false);
      setCashInHandSuccess(false);
    };
  }, [currentPage, updateCashSuccess, cashInHandSuccess]);

  const updateCashInHand = async () => {
    if (updateCashPayload.cash_in_hand) {
      try {
        setLoading(true);
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userDataFromStorage.token}`,
          },
        };
        const { data } = await axios.put(
          `${API_HOST}/api/cash_start/`,
          updateCashPayload,
          config
        );

        if (data) {
          toast.success(data.message);
          setUpdateCashSuccess(true);
          setLoading(false);
          setCashAdjustModel(false);
        }
      } catch (error) {
        toast.error(error);
      }
    }
  };

  useEffect(() => {
    if (agentModelData) {
      setUpdateCashPayload({
        _id: agentModelData._id,
        cash_in_hand: agentModelData.cash_in_hand,
        agent: agentModelData.agent,
      });
    }
  }, [agentModelData]);

  useEffect(() => {
    if (open === true) {
      setCashAdjustModel(false);
    }
  }, [open]);

  useEffect(() => {
    getCashStartList();
  }, [agentNameForApi, managerNameForApi]);

  const handleAgentNameChange = useCallback((e) => {
    setAgentLastName(e.target.value);
  }, []);

  const handleManagerNameChange = useCallback((e) => {
    setManagerLastName(e.target.value);
  }, []);

  const filteredAgentOptions = useMemo(() => {
    if (agentLastName && !selectedAgentName) {
      console.log("here");
      const searchTerm = agentLastName.toLowerCase();
      const optionsStartingWithSearchTerm = [];

      console.log("searchTerm", searchTerm);

      agentNameList.forEach((option) => {
        if (
          option.agent_name &&
          option.agent_name.toLowerCase().startsWith(searchTerm)
        ) {
          console.log(
            "option.agent_name.toLowerCase().startsWith(searchTerm)",
            option.agent_name.toLowerCase().startsWith(searchTerm)
          );
          optionsStartingWithSearchTerm.push(option);
        }
      });

      optionsStartingWithSearchTerm.sort((a, b) =>
        a.agent_name.localeCompare(b.agent_name, undefined, {
          sensitivity: "base",
        })
      );

      console.log(
        "optionsStartingWithSearchTerm",
        optionsStartingWithSearchTerm
      );

      // setAgentLastName("");

      return optionsStartingWithSearchTerm;
    } else {
      console.log("here agent");
      if (selectedAgentName) {
        console.log("here agent1111");
        setAgentNameForApi(selectedAgentName);
        setSelectedAgentName("");

        searchFilterOptionsShowAgent.current = false;
      } else {
        console.log("here agent222");
        searchFilterOptionsShowAgent.current = true;
      }

      return [];
    }
  }, [agentLastName, selectedAgentName]);

  const filteredManagerOptions = useMemo(() => {
    if (managerLastName && !selectedManagerName) {
      console.log("here");
      const searchTerm = managerLastName.toLowerCase();
      const optionsStartingWithSearchTerm = [];

      console.log("searchTerm", searchTerm);

      managerNameList.forEach((option) => {
        if (
          option.manager_name &&
          option.manager_name.toLowerCase().startsWith(searchTerm)
        ) {
          console.log(
            "option.manager_name.toLowerCase().startsWith(searchTerm)",
            option.manager_name.toLowerCase().startsWith(searchTerm)
          );
          optionsStartingWithSearchTerm.push(option);
        }
      });

      optionsStartingWithSearchTerm.sort((a, b) =>
        a.manager_name.localeCompare(b.manager_name, undefined, {
          sensitivity: "base",
        })
      );

      console.log(
        "optionsStartingWithSearchTerm",
        optionsStartingWithSearchTerm
      );

      // setAgentLastName("");

      return optionsStartingWithSearchTerm;
    } else {
      console.log("here agent");
      if (selectedManagerName) {
        setManagerNameForApi(selectedManagerName);
        setSelectedManagerName("");

        searchFilterOptionsShowManager.current = false;
      } else {
        searchFilterOptionsShowManager.current = true;
      }

      return [];
    }
  }, [managerLastName, selectedManagerName]);

  useEffect(() => {
    if (allUsers.length) {
      async function fetchData() {
        let combinedArray;

        if (agentNameForApi && !managerNameForApi) {
          let userDetail = allUsers.filter(
            (x) => x.last_name === agentNameForApi
          );
          combinedArray = await Promise.all(
            userDetail.map(async (item1) => {
              const matchingItem1 =
                filterData.find(
                  (item2) => item2.agent_id === item1.employee_number
                ) || {};

              return {
                agent_id: item1.employee_number,
                date_set: matchingItem1.date_set || "---",
                cash_in_hand:
                  matchingItem1.cash_in_hand !== null &&
                  matchingItem1.cash_in_hand !== undefined
                    ? matchingItem1.cash_in_hand
                    : "---",
                agent: item1.agent_name || item1.last_name,
                manager: item1.managerName ? item1.managerName : "",
                _id: matchingItem1._id || "---",
              };
            })
          );
        } else if (managerNameForApi && !agentNameForApi) {
          let managerCheck = allUsers.find(
            (y) => y.last_name === managerNameForApi
          );
          if (managerCheck) {
            let userDetail = allUsers.filter(
              (x) => x.manager === managerCheck.employee_number
            );
            combinedArray = await Promise.all(
              userDetail.map(async (item1) => {
                const matchingItem1 =
                  filterData.find(
                    (item2) => item2.agent_id === item1.employee_number
                  ) || {};

                return {
                  agent_id: item1.employee_number,
                  date_set: matchingItem1.date_set || "---",
                  cash_in_hand:
                    matchingItem1.cash_in_hand !== null &&
                    matchingItem1.cash_in_hand !== undefined
                      ? matchingItem1.cash_in_hand
                      : "---",
                  agent: item1.agent_name || item1.last_name,
                  manager: item1.managerName ? item1.managerName : "",
                  _id: matchingItem1._id || "---",
                };
              })
            );
          }
        } else if (managerNameForApi && agentNameForApi) {
          let managerCheck = allUsers.find(
            (y) => y.last_name === managerNameForApi
          );
          let agentCheck = allUsers.find(
            (z) => z.last_name === agentNameForApi
          );
          if (agentCheck && managerCheck) {
            if (agentCheck.manager === managerCheck.employee_number) {
              let userDetail = allUsers.filter(
                (x) => x.last_name === agentNameForApi
              );
              combinedArray = await Promise.all(
                userDetail.map(async (item1) => {
                  console.log("item1:::", item1);
                  const matchingItem1 =
                    filterData.find(
                      (item2) => item2.agent_id === item1.employee_number
                    ) || {};

                  return {
                    agent_id: item1.employee_number,
                    date_set: matchingItem1.date_set || "---",
                    cash_in_hand:
                      matchingItem1.cash_in_hand !== null &&
                      matchingItem1.cash_in_hand !== undefined
                        ? matchingItem1.cash_in_hand
                        : "---",
                    agent: item1.agent_name || item1.last_name,
                    manager: item1.managerName ? item1.managerName : "",
                    _id: matchingItem1._id || "---",
                  };
                })
              );
            }
          }
        } else {
          combinedArray = await Promise.all(
            allUsers.map(async (item1) => {
              const matchingItem1 =
                filterData.find(
                  (item2) => item2.agent_id === item1.employee_number
                ) || {};

              return {
                agent_id: item1.employee_number,
                date_set: matchingItem1.date_set || "---",
                cash_in_hand:
                  matchingItem1.cash_in_hand !== null &&
                  matchingItem1.cash_in_hand !== undefined
                    ? matchingItem1.cash_in_hand
                    : "---",
                agent: item1.agent_name || item1.last_name,
                manager: item1.managerName ? item1.managerName : "",
                _id: matchingItem1._id || "---",
              };
            })
          );
        }

        console.log("flattenedArray", combinedArray);

        setOverAllData(combinedArray);
      }

      fetchData();
    }
  }, [filterData, allUsers, agentNameForApi, managerNameForApi]);

  return (
    <div
      className={
        userDataFromStorage.user_role === "admin"
          ? "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50  overflow-hidden"
          : "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50 overflow-hidden"
      }>
      <p className="text-gray-800 md:text-[1.8rem] text-[1.3rem] tracking-wider">
        Cash Starting Points
      </p>

      <div className="bg-white mt-[2%] pb-[1rem]">
        <p
          style={{ backgroundColor: coloredTheme }}
          className=" text-white px-[0.5rem] py-[1rem]">
          Agent Selection
        </p>
        <div className="px-[0.5rem] mt-2">
          <div className="relative md:flex justify-start items-center mt-6">
            <p className="w-[30%]">Manager Last Name</p>
            <input
              type="text"
              value={managerLastName}
              placeholder="Enter Manager Last Name"
              onInput={(e) => {
                console.log("e.target::::::", e.target.value);
                handleManagerNameChange(e);
              }}
              className="outline-none  border border-gray-300 rounded-lg  w-[70%]   p-[0.8rem] "
            />
            {filteredManagerOptions.length > 0 && (
              <div
                className={
                  searchFilterOptionsShowManager?.current
                    ? "absolute 2xl:top-[4rem] lg:top-[4rem] lg:max-h-[12rem] xl:top-[4rem] xl:max-h-[12rem] 2xl:max-h-[13rem] overflow-y-scroll w-[100%]  rounded-lg shadow-xl bg-white z-10"
                    : "hidden"
                }>
                {filteredManagerOptions.map((option, index) => (
                  <div
                    className="bg-white cursor-pointer p-[0.5rem] hover:bg-cyan-200 transition duration-[0.3s]"
                    onClick={() => {
                      setSelectedManagerName(option.manager_name);
                      setManagerLastName(option.manager_name);
                    }}
                    key={index}>
                    {option.manager_name}
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="relative md:flex justify-start items-center mt-6">
            <p className="w-[30%]">Agent Last Name</p>
            <input
              type="text"
              value={agentLastName}
              placeholder="Enter Agent Last Name"
              onInput={(e) => {
                console.log("e.target::::::", e.target.value);
                handleAgentNameChange(e);
              }}
              className="outline-none  border border-gray-300 rounded-lg  w-[70%]   p-[0.8rem] "
            />
            {filteredAgentOptions.length > 0 && (
              <div
                className={
                  searchFilterOptionsShowAgent.current === true
                    ? "absolute 2xl:top-[4rem] lg:top-[4rem] lg:max-h-[12rem] xl:top-[4rem] xl:max-h-[12rem] 2xl:max-h-[13rem] overflow-y-scroll w-[100%]  rounded-lg shadow-xl bg-white z-10"
                    : "hidden"
                }>
                {filteredAgentOptions.map((option, index) => (
                  <div
                    className="bg-white cursor-pointer p-[0.5rem] hover:bg-cyan-200 transition duration-[0.3s]"
                    onClick={() => {
                      console.log("option.agent_name::", option.agent_name);
                      setAgentLastName(option.agent_name);
                      setSelectedAgentName(option.agent_name);
                    }}
                    key={index}>
                    {option.agent_name}
                  </div>
                ))}
              </div>
            )}
          </div>
          {/* <div className='mt-6 flex justify-start items-center'>
                        <p className='w-[25rem]'>Last Cash Recorded Only</p>
                        <div className='flex'>
                            <input type="radio" id="Yes" />
                            <label className='ml-1 mr-4' htmlFor='Yes'>Yes</label>
                            <input type="radio" id="No" />
                            <label className='ml-1' htmlFor='No'>No</label>
                        </div>
                    </div> */}
          <div className="flex justify-start items-center space-x-4">
            <button
              onClick={() => getCashStartList()}
              style={{ backgroundColor: coloredTheme }}
              className="flex  justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white ">
              <FiSearch />
              <p>Search</p>
            </button>
            <button
              onClick={() => {
                setManagerLastName("");
                setAgentLastName("");
                setFilterData(managerAgentCashList);
                setManagerNameForApi("");
                setAgentNameForApi("");
              }}
              style={{ backgroundColor: coloredTheme }}
              className="flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white ">
              <FaUndo />
              <p>Reset</p>
            </button>
          </div>
        </div>
      </div>

      <div className="mt-8 overflow-scroll">
        <p
          style={{ backgroundColor: coloredTheme }}
          className="text-white lg:w-[100%] md:w-[130%] w-[250%]  px-[0.5rem] py-[1rem]">
          Agent Details - Click on a row to see Cash Adjustment for that agent
        </p>
        <table className="lg:w-[100%] md:w-[130%] w-[250%]">
          <thead className="h-[5vh] ">
            <tr>
              <th className="text-start">Manager</th>
              <th className="text-start">Agent</th>
              <th className="text-start">Cash In Hand</th>
              <th className="text-start">Date Cash Amount Set</th>
            </tr>
          </thead>
          <tbody>
            {overAllData && overAllData.length
              ? overAllData.map((x) => {
                  let todayDate = new Date();
                  const inputDate = new Date(x?.date_set);

                  const months = [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December",
                  ];

                  console.log("input date", inputDate);

                  const day = inputDate.getDate();
                  console.log("day::::", day);
                  const month = months[inputDate.getMonth()];
                  const year = inputDate.getFullYear();

                  console.log("year::::::::::", year);
                  console.log("x.dateset::::::::::", x.date_set);
                  console.log("today::::::::::", todayDate.getFullYear());

                  const formattedDate = `${day} ${month}, ${year}`;

                  const parsedDate = Date.parse(formattedDate);

                  return (
                    <tr
                      onClick={() => {
                        setCashAdjustModel(true);
                        setAgentModelData(x);
                      }}
                      key={x.agent_id}
                      className="border-b bg-white hover:bg-purple-50 cursor-pointer transition duration-[0.3s] h-[4rem]">
                      <td>{x.manager}</td>
                      <td>{x.agent}</td>
                      <td>
                        {x.cash_in_hand === "---"
                          ? ""
                          : `MYR ${x.cash_in_hand}`}
                      </td>
                      <td>{!isNaN(parsedDate) ? formattedDate : ""}</td>

                      <td className="py-[1rem]">
                        {!isNaN(parsedDate) ? (
                          " "
                        ) : (
                          <button
                            onClick={(e) => {
                              // setCashAdjustModel(false);
                              e.preventDefault();
                              setOpen(true);

                              setAddCashStart((prevState) => ({
                                ...prevState,
                                agent: x.agent_id,
                                id: x._id,
                              }));
                            }}
                            style={{
                              backgroundColor: coloredTheme,
                            }}
                            className="flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem]  text-white ">
                            <MdAdd />
                            <p>New Cash In Hand</p>
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })
              : ""}
          </tbody>
        </table>

        {/* <div className="flex justify-end space-x-4 items-center mt-4  h-[50%]">
          <button
            className=" px-6 py-2 rounded-lg text-white bg-gray-400 hover:bg-gray-200 shadow-xl hover:text-gray-600 transition duration-[0.5s] tracking-wider"
            onClick={() => setCurrentPage(currentPage - 1)}
            disabled={currentPage === 1}>
            Prev
          </button>
          <button
            className=" px-6 py-2 rounded-lg text-white bg-gray-400 hover:bg-gray-200 shadow-xl hover:text-gray-600 transition duration-[0.5s] tracking-wider"
            onClick={() => setCurrentPage(currentPage + 1)}>
            Next
          </button>
        </div> */}
      </div>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem]">
        <Box className="lg:w-[50%] md:w-[50%] w-[95%] rounded-lg bg-white absolute top-[10%]  mb-[10rem] ">
          {loading ? (
            <Loader />
          ) : (
            <>
              <div className="p-[0.5rem]">
                <p className="text-lg text-gray-800">Set Cash In Hand</p>
              </div>
              <Divider />
              <div className="p-[0.5rem]">
                <div className="grid grid-cols-4 mt-2">
                  <label
                    htmlFor="cashInHand"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Cash In Hand</span>
                  </label>
                  <input
                    onChange={(e) =>
                      setAddCashStart((prevState) => ({
                        ...prevState,
                        cash_in_hand: e.target.value,
                      }))
                    }
                    value={addCashStart?.cash_in_hand}
                    type="number"
                    id="cashInHand"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Enter A Cash In Hand Amount"
                  />
                </div>

                <div className="grid grid-cols-4 mt-2">
                  <label
                    htmlFor="newPass"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Date Set</span>
                  </label>
                  <input
                    onChange={(e) =>
                      setAddCashStart((prevState) => ({
                        ...prevState,
                        date_set: e.target.value,
                      }))
                    }
                    value={addCashStart?.date_set}
                    type="date"
                    id="newPass"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Enter User New Password"
                  />
                </div>

                <div className="flex justify-end items-center space-x-4 mt-8 mb-4">
                  <button
                    style={{ backgroundColor: coloredTheme }}
                    onClick={() => setOpen(false)}
                    className="flex justify-center items-center space-x-2  text-purple-50 px-[1rem] py-[0.5rem] rounded   hover:shadow-2xl hover:shadow-black">
                    <TbArrowBackUp />
                    <p>Cancel</p>
                  </button>
                  <button
                    style={{ backgroundColor: coloredTheme }}
                    onClick={() => addCashStartHandler()}
                    className="flex justify-center items-center space-x-2 text-white px-[1rem] py-[0.5rem] rounded   hover:shadow-2xl hover:shadow-black ">
                    <RiSave2Fill />
                    <p>Save</p>
                  </button>
                </div>
              </div>
            </>
          )}
        </Box>
      </Modal>

      <Modal
        open={cashAdjustModel}
        onClose={() => setCashAdjustModel(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem]">
        <Box className="lg:w-[50%] md:w-[50%] w-[95%] rounded-lg bg-white absolute top-[10%]  mb-[10rem] ">
          {loading ? (
            <Loader />
          ) : (
            <>
              <div className="p-[0.5rem]">
                <p className="text-lg text-gray-800">Change Cash Value</p>
              </div>
              <Divider />
              <div className="p-[0.5rem]">
                <div className="grid grid-cols-4 mt-2">
                  <p className="col-span-1">Agent</p>
                  <p className="col-span-3 ml-2">{agentModelData.agent}</p>
                </div>

                <div className="grid grid-cols-4 mt-2">
                  <label
                    htmlFor="newPass"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Cash In Hand</span>
                  </label>
                  <input
                    onChange={(e) =>
                      setUpdateCashPayload((prevState) => ({
                        ...prevState,
                        cash_in_hand: e.target.value,
                        _id: agentModelData._id,
                        date_set: new Date(),
                      }))
                    }
                    value={updateCashPayload?.cash_in_hand}
                    type="number"
                    id="cashInHandChange"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Enter Cash In Hand Adjustment"
                  />
                </div>

                <div className="flex justify-end items-center space-x-4 mt-8 mb-4">
                  <button
                    style={{ backgroundColor: coloredTheme }}
                    onClick={() => setCashAdjustModel(false)}
                    className="flex justify-center items-center space-x-2  text-purple-50 px-[1rem] py-[0.5rem] rounded   hover:shadow-2xl hover:shadow-black">
                    <TbArrowBackUp />
                    <p>Cancel</p>
                  </button>
                  <button
                    style={{ backgroundColor: coloredTheme }}
                    onClick={() => updateCashInHand()}
                    className="flex justify-center items-center space-x-2 text-white px-[1rem] py-[0.5rem] rounded   hover:shadow-2xl hover:shadow-black ">
                    <RiSave2Fill />
                    <p>Save</p>
                  </button>
                </div>
              </div>
            </>
          )}
        </Box>
      </Modal>
      <ToastContainer
        newestOnTop={false}
        rtl={false}
        transition={Flip}
        position="top-right"
        autoClose={2000}
        theme="dark"
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={false}
        draggable={true}
        progress={undefined}
        className="text-center"
      />
    </div>
  );
}

export default CashStart;
